// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8l-4";
export var collapsed = "_8l-1";
export var headerBar = "_8l-0";
export var leftHeaderContent = "_8l-3";
export var subjectContainer = "_8l-2";